module.exports = __webpack_public_path__ + "static/story-f34398eee6c949985af26a7e045e91a8.jpg";